import {useHttp, useLogger} from '@deliveryhero/vendor-web-core';
import {useCallback, useState} from 'react';
import {HEARTBEAT_URL} from '../configs/heartbeatApi';
import {isAxiosErrorToFilter} from '../utils/isAxiosErrorToFilter';

interface UseApiResponse {
  error: unknown;
  sendHeartbeat: () => Promise<unknown>;
}

export function useHeartbeatApi(): UseApiResponse {
  const http = useHttp();
  const logger = useLogger();

  const [error, setError] = useState<unknown | undefined>(undefined);
  const c = useCallback(
    async (): Promise<unknown> => {
      try {
        await http.post(
          HEARTBEAT_URL,
          {},
          {
            headers: {
              'X-Rps-Client-App-Name': 'OneWeb',
            },
          },
        );

        setError(undefined);
      } catch (err: unknown) {
        if (!isAxiosErrorToFilter(err)) {
          logger.error(`useHeartbeatApi: Failed to make heartbeat call`, err, {});
        }

        setError(err);
      }
      return null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [http],
  );

  return {error, sendHeartbeat: c};
}
